export const useProductFormat = (item: any, existingItem: any) => {
  const discountPercentage = Math.round(((item.max_price - item.price) / item.max_price) * 100);
  const hasVariant = item.variants?.[0]?.variants?.length > 0 || false;

  return {
    parent_item_id: item.sku_id,
    sku_id: item.sku_id,
    item_id: item.item_id,
    name: item.name,
    category: item.category.name,
    image: item.images.thumbnail,
    price: existingItem?.price || item.price,
    max_price: item.max_price,
    discount_percentage: discountPercentage,
    qty: existingItem?.qty || item.qty || 1,
    uom: item.uom ? [Number(item.uom[0]).toFixed(0), ...item.uom.slice(1)].join(' ') : null,
    attributes: item.attributes || [],
    has_variant: hasVariant,
    variants: item.variants?.[0] || [],
    is_stock_available: item.stock.available > 0 || false,
    max_qty_allowed: Number(item.stock.maximum || 10),
    total: existingItem?.total || item.price * item.qty,
    ...(discountPercentage > 0 ? { promo_text: discountPercentage + '% off' } : {}),
    meta: { ...item, parent_item_id: item.sku_id },
  };
}